module.exports = __webpack_public_path__ + "assets/img/052c1d39cab50003fdb8857d212981fb.png";